import { Button, useAuthenticator } from '@aws-amplify/ui-react';
import {
    Card, CardContent,
    CardMedia, Grid, Link, makeStyles, Slide, Typography
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import { Auth } from 'aws-amplify';
import React from 'react';
import { connect } from 'react-redux';
import { Branding, theme } from '../../branding';
import { setUser } from '../../redux/actions';
import SignInContainer from '../LandingPage/signInContainer';
import AppSnackbar from '../Snackbar/Snackbar';

const config = require("Config");

const useStyles = makeStyles((theme) => ({
    title: {
        color: Branding.primary,
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    desc: {
        color: Branding.lightBlack,
        fontSize: "14px",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        flex: 1,
    },
    rootGrid: {
        background: Branding.body,
        marginTop: theme.spacing(10),
        paddingBottom: theme.spacing(3),
    },
    grid: {
        justifyContent: 'center',
    },
    card: {
        maxWidth: '35em',
        justifyContent: 'center',
    },
    cardMedia: {
        width: 200,
        height: 90,
        backgroundSize: 'contain',
    },
    cardHeader: {
        paddingBottom: 0
    },
    cardContent: {
        padding: "2em 2em",
        "&:last-child": {
            paddingBottom: theme.spacing(5)
        }
    },
    divider: {
        marginBottom: theme.spacing(2)
    },
    errorMessage: {
        color: "red",
        marginTop: theme.spacing(1),
        fontWeight: "bold",
        fontSize: "12px"
    },
    message: {
        fontWeight: 'bold',
        marginTop: "2em",
        fontSize: "12px",
        color: Branding.primary
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    formControl: {
        margin: theme.spacing(3),
    },
    radioButton: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    formControlLabel: {
        fontWeight: "500",
        fontSize: "16px"
    },
    link: {
        fontSize: 12,
        fontWeight: "bold",
        color: Branding.link,
        '&:hover': {
            cursor: 'pointer',
            color: Branding.accent,
            opacity: Branding.opacityHover,
        },
    },
    midBul: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        color: Branding.secondary,
    },
    typoToS: {
        paddingTop: theme.spacing(3),

    }
}));


const mapStateToProps = (state) => {
    return {
        user: state.app.user,
        lang: state.app.lang
    }
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const LinkMyAccount = (props) => {

    const { onClose, open } = props;
    const classes = useStyles();
    const [isLoading, setIsLoading] = React.useState(false);
    const [stepCount, setStepCount] = React.useState(props.currentStep || 1);
    const [snackBarOps, setSnackBarOps] = React.useState({});
    const [isLinkAccountFlow, setIsLinkAccountFlow] = React.useState(sessionStorage.getItem("link_acc_token") || null);
    const { authStatus, user } = useAuthenticator(context => [context.authStatus, context.user]);

    const handleClose = () => {
        onClose();
        sessionStorage.removeItem("link_acc_token");
        setStepCount(1);
    };


    React.useEffect(() => {
        if (user) {
            props.setUser(user);
        }
    }, [user])

    React.useEffect(() => {
        if (isLinkAccountFlow) {
            const div = document.querySelector('body')
            if (div) div.style.background = Branding.white;
        }
        else {
            const div = document.querySelector('body')
            if (div) div.style.background = Branding.body;
        }
    })

    const getVerificationCodeToLinkMyAccount = async () => {
        return new Promise((resolve, reject) => {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${props.user.signInUserSession.accessToken.jwtToken}`
                },
                body: JSON.stringify({ type: 'code' })
            };

            const path = '/api/v1/link/my/account';
            setSnackBarOps(null);
            setIsLoading(true);
            fetch((config.apiHost + path), requestOptions)
                .then(async (res) => {
                    return { status: res.status, message: res.message, ...await res.json() }
                })
                .then((response) => {
                    if (response.status !== 200) {
                        throw new Error(response.message);
                    }
                    setIsLoading(false);
                    resolve(response.token);
                }).catch(err => {
                    console.log(err);
                    setSnackBarOps({
                        type: 'error',
                        open: true,
                        vertical: 'bottom',
                        horizontal: 'center',
                        autoHide: 3000,
                        message: err.message || "Something went wrong"
                    });
                    setIsLoading(false);
                    reject();
                });
        });
    }

    const handleNextClick = async (event) => {
        event.preventDefault();
        if (stepCount + 1 === 2) {
            try {
                const token = sessionStorage.getItem("link_acc_token") || await getVerificationCodeToLinkMyAccount();
                sessionStorage.setItem("link_acc_token", token);
                setIsLinkAccountFlow(true);
                setIsLoading(true);
                if (props.user)
                    await Auth.signOut();

                setIsLoading(false);
                setStepCount(stepCount + 1);
                if (isLinkAccountFlow) {
                    const div = document.querySelector('body')
                    if (div) div.style.background = Branding.white;
                }
                return
            } catch (error) {
                console.log(error);
            }
            return
        }
        setStepCount(stepCount + 1);
    }

    const handlePreviousClick = () => {
        if (stepCount - 1 === 0) {
            return handleClose();
        }
        setStepCount(stepCount - 1);
    }

    return (
        <Dialog PaperProps={{
            style: {
                backgroundColor: Branding.body,
                boxShadow: 'none',
            },
        }} style={{ backgroundColor: Branding.body }} onClose={handleClose} fullScreen aria-labelledby="simple-dialog-title" open={open} TransitionComponent={Transition}>
            <div style={{ backgroundColor: Branding.body }}>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    className={classes.rootGrid}
                >
                    <CardMedia
                        className={classes.cardMedia}
                        image={"https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"}
                        title={Branding.appName}
                    />
                </Grid>

                <Grid container className={classes.grid}>
                    <Card variant="outlined" className={classes.card}>
                        <CardContent className={classes.cardContent}>

                            {
                                stepCount === 1 ?

                                    <Fade in={stepCount === 1}>
                                        <div style={{ textAlign: "center" }}>
                                            <Typography style={{ fontSize: "18px", fontWeight: "600" }} className={classes.desc}>
                                                You will be asked to login to your existing YouScience account to complete the process.
                                            </Typography>

                                            <Typography style={{ fontSize: "22px", fontWeight: "700" }} className={classes.desc}>
                                                Do you want to proceed?
                                            </Typography>

                                            <Typography>
                                                <Button onClick={handlePreviousClick} style={{ fontSize: "14px", paddingLeft: theme.spacing(5), paddingRight: theme.spacing(5), marginRight: theme.spacing(2), fontWeight: "700" }} variation="secondary" className={classes.button}> No </Button>
                                                <Button isLoading={isLoading} loadingText="Please wait..." onClick={handleNextClick} style={{ fontSize: "14px", paddingLeft: theme.spacing(5), paddingRight: theme.spacing(5), marginRight: theme.spacing(2), fontWeight: "700" }} variation="primary" className={classes.button}> Yes</Button>
                                            </Typography>

                                            <Typography style={{ fontSize: "12px", color: Branding.secondary, marginTop: theme.spacing(1), fontStyle: "italic", fontWeight: "400" }} className={classes.desc}>
                                                Note: You will be logged out from the current session.
                                            </Typography>
                                        </div>
                                    </Fade> : <> </>
                            }

                            {stepCount === 2 ?
                                <Fade in={stepCount === 2}>
                                    <Grid direction="column" container>
                                        <Typography style={{ textAlign: "center", fontSize: "18px", fontWeight: "600", marginBottom: theme.spacing(0) }} className={classes.desc}>
                                            Sign In to your existing YouScience account
                                        </Typography>
                                        <SignInContainer style={{ alignItems: "left" }} authState={authStatus} isLinkAccountFlow={isLinkAccountFlow} />
                                        <div style={{ textAlign: "center" }}>
                                            <Grid direction='row' style={{ justifyContent: 'center' }} container>
                                                <Typography className={classes.typoToS}>
                                                    <Link
                                                        onClick={handleClose}
                                                        className={classes.link}
                                                    >
                                                        Close
                                                    </Link>
                                                </Typography>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Fade>
                                : null
                            }

                        </CardContent>
                    </Card>
                </Grid>

                {snackBarOps && snackBarOps.open && (
                    <AppSnackbar ops={snackBarOps} />
                )}

            </div>
        </Dialog>
    )
}

export default connect(mapStateToProps, { setUser })(LinkMyAccount);